/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { call, put, takeEvery } from "redux-saga/effects";

import { setUser } from "../actions";
import { services } from "../../services";
import { getErrorFromCode } from "../../utils/errorHelper";

export function* putMockData(action) {
    const user = yield verboseCall(() => services.api.user.testStressCustomers());
    yield put(setUser(user));
}

export function* testSaga() {
    yield takeEvery("test.putMockData", putMockData);
}

/**
 * Display threwed Error and rethrow it.
 */
export function verboseCall(cb: () => void) {
    return call(async () => {
        try {
            return await cb();
        } catch (error) {
            if (error.code) {
                throw getErrorFromCode(error.code);
            }
            window.console.error(error);
            throw error;
        }
    });
}



// WEBPACK FOOTER //
// ./src/store/sagas/index.ts